var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgApprovedTick = function SvgApprovedTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.669,
    height: 59.472,
    viewBox: "0 0 64.669 59.472",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(308.967 120.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M68.5,38.688a9.178,9.178,0,0,1,0-7.531l.359-.793c2.3-5.021-.359-10.834-5.818-12.948l-.79-.33a10.134,10.134,0,0,1-5.818-5.351l-.287-.661C53.78,6.053,47.531,3.675,42,5.723l-.718.264a11.847,11.847,0,0,1-8.26,0l-.646-.264c-5.387-2.048-11.708.4-14.006,5.417l-.287.529a10.134,10.134,0,0,1-5.818,5.351l-.646.264C6.23,19.4,3.573,25.211,5.871,30.232l.287.595a9.178,9.178,0,0,1,0,7.531l-.287.727c-2.3,5.021.287,10.834,5.818,12.882l.718.264a10.134,10.134,0,0,1,5.818,5.351l.359.727c2.227,5.087,8.547,7.465,14.006,5.417l.79-.33a11.847,11.847,0,0,1,8.26,0l.646.264c5.459,2.114,11.78-.33,14.078-5.351l.287-.529a10.134,10.134,0,0,1,5.818-5.351l.575-.2c5.531-2.114,8.116-7.862,5.818-12.948Zm-34.19,8.919h0L20.308,36.773l4.31-4.691,8.907,6.937,15.73-17.177,5.1,3.964-20.04,21.8Z",
    transform: "translate(-314 -125)",
    fill: "#23c373"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApprovedTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approvedTick.1826292f.svg";
export { ForwardRef as ReactComponent };